import { Link } from 'react-router-dom'

export const LandingFooter = () => (
  <footer className="py-12 px-4 border-t border-border bg-white">
    <div className="max-w-6xl mx-auto">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-10">
        {/* Brand */}
        <div className="col-span-2 sm:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 bg-primary rounded-lg flex items-center justify-center text-white text-xs font-bold">D</div>
            <span className="font-display font-bold text-primary text-lg">DoorChart</span>
          </div>
          <p className="text-xs text-text-muted leading-relaxed max-w-[180px]">
            The household organiser built for real family life.
          </p>
        </div>

        {/* Product */}
        <div>
          <h4 className="text-xs font-semibold text-text-primary uppercase tracking-wider mb-3">Product</h4>
          <ul className="space-y-2 text-sm text-text-muted">
            <li><a href="#features" className="hover:text-text-primary transition-colors">Features</a></li>
            <li><a href="#pricing" className="hover:text-text-primary transition-colors">Pricing</a></li>
            <li><a href="#how-it-works" className="hover:text-text-primary transition-colors">How it works</a></li>
            <li><a href="#faq" className="hover:text-text-primary transition-colors">FAQ</a></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-xs font-semibold text-text-primary uppercase tracking-wider mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-text-muted">
            <li><a href="mailto:hello@doorchart.com" className="hover:text-text-primary transition-colors">Contact</a></li>
            <li><Link to="/help" className="hover:text-text-primary transition-colors">Help Center</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-xs font-semibold text-text-primary uppercase tracking-wider mb-3">Legal</h4>
          <ul className="space-y-2 text-sm text-text-muted">
            <li><Link to="/privacy" className="hover:text-text-primary transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-text-primary transition-colors">Terms of Service</Link></li>
          </ul>
        </div>
      </div>

      <div className="pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-text-muted">© {new Date().getFullYear()} DoorChart. All rights reserved.</p>
        <p className="text-xs text-text-muted">Made with care for busy families 🏠</p>
      </div>
    </div>
  </footer>
)
